/* NOBL landing pages (lpe-*) | shared behaviour for every section used by layout/landing-page.liquid.
   - Countdown timers ([data-timer], [data-timer-long], [data-cd]) to the end time set in "LP: Page settings".
   - Lazy video play/pause, tabs, carousels, gallery thumbnails, desktop sticky bar (body.scrolled),
     and the "Pick a card" game.
   - Buy box: product options, colour swatches, prices from Shopify, quantity.
   - Buy buttons ([data-lpe-buy]): product page, or add to cart and let the store's existing Gift Manager
     (snippets/free-gift.liquid, window.GiftManager) add and verify the free gifts before going to
     checkout / cart. Same flow as the PDP direct-checkout button (snippets/buy-buttons-bundle-pro.liquid).
   - Free gift preview: asks window.GiftManager.computeUpdates() which gifts the selected product earns,
     so the gifts shown always follow the gift rules in Theme settings. No gift IDs live in this file.
     A display-only gift set on the buy box option (e.g. NOBL Air(TM), as on the PDPs) is listed after
     them; it is never added to the cart.
   Safe to load once per page; re-initialises sections reloaded in the theme editor. */
(function () {
  'use strict';
  if (window.LPECore) return;

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var designMode = !!(window.Shopify && window.Shopify.designMode);
  var state = null;
  var busy = false;

  function qsa(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function pad(n) { return String(n).padStart(2, '0'); }
  function cartUrl() { return (window.routes && window.routes.cart_url) || root + 'cart'; }

  /* ---------- countdown ---------- */
  function endTime() {
    var e = window.LPE && window.LPE.end;
    var t = e ? Date.parse(e) : NaN;
    return isNaN(t) ? null : t;
  }
  function tick() {
    var end = endTime();
    if (end === null) return;
    var s = Math.max(0, Math.floor((end - Date.now()) / 1000));
    var d = Math.floor(s / 86400), r = s % 86400;
    var h = Math.floor(r / 3600), m = Math.floor((r % 3600) / 60), x = r % 60;
    var short = (d ? d + 'D ' : '') + pad(h) + 'H ' + pad(m) + 'M ' + pad(x) + 'S';
    qsa('[data-timer]').forEach(function (el) { el.textContent = short; });
    var parts = [[d, 'day'], [h, 'hour'], [m, 'minute'], [x, 'second']]
      .filter(function (p, i) { return p[0] > 0 || i === 3; })
      .map(function (p) { return p[0] + ' ' + p[1] + (p[0] === 1 ? '' : 's'); });
    var long = parts.length > 1 ? parts.slice(0, -1).join(' ') + ' and ' + parts[parts.length - 1] : parts[0];
    qsa('[data-timer-long]').forEach(function (el) { el.textContent = long; });
    var cells = { d: pad(d), h: pad(h), m: pad(m), s: pad(x) };
    qsa('[data-cd]').forEach(function (el) { el.textContent = cells[el.getAttribute('data-cd')]; });
  }

  /* ---------- lazy videos ---------- */
  var videoObserver = ('IntersectionObserver' in window) ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      var v = e.target;
      if (e.isIntersecting) { v.preload = 'auto'; var p = v.play(); if (p && p.catch) p.catch(function () {}); }
      else v.pause();
    });
  }, { rootMargin: '200px' }) : null;
  function initVideos(ctx) {
    qsa('video[data-lazy]', ctx).forEach(function (v) {
      if (v.__lpeObserved) return;
      v.__lpeObserved = true;
      if (videoObserver) videoObserver.observe(v); else { v.preload = 'auto'; }
    });
  }

  /* ---------- Gift Manager helpers ---------- */
  function giftManager() {
    var GM = window.GiftManager;
    return GM && typeof GM.computeUpdates === 'function' ? GM : null;
  }
  function waitForGiftManager(ms) {
    return new Promise(function (resolve) {
      var start = Date.now();
      (function check() {
        if (window.GiftManager) return resolve(window.GiftManager);
        if (Date.now() - start > ms) return resolve(null);
        setTimeout(check, 50);
      })();
    });
  }
  var catalog = null;
  function giftCatalog() {
    if (catalog) return catalog;
    var el = document.querySelector('[data-lpe-gift-catalog]');
    try { catalog = el ? JSON.parse(el.textContent) : {}; } catch (e) { catalog = {}; }
    return catalog;
  }
  // Gifts the Gift Manager would add if the cart held only the selected variant x quantity.
  // Returns null while the Gift Manager is not available.
  function previewGifts(s) {
    var GM = giftManager();
    if (!GM || !s || !s.v) return null;
    var q = s.qty, price = s.v.p;
    var item = {
      id: Number(s.vid), variant_id: Number(s.vid), product_id: Number(s.pid), key: s.vid + ':lpe-preview',
      quantity: q, price: price, final_price: price, original_price: price, discounted_price: price,
      line_price: price * q, final_line_price: price * q, original_line_price: price * q,
      properties: {}, options_with_values: (s.v.o || []).map(function (o) { return { name: o[0], value: o[1] }; })
    };
    var cart = { token: 'lpe-preview', items: [item], item_count: q, total_price: price * q,
      original_total_price: price * q, items_subtotal_price: price * q, total_discount: 0 };
    var updates;
    try { updates = GM.computeUpdates(cart); } catch (e) { return null; }
    var out = [];
    Object.keys(updates || {}).forEach(function (k) {
      var n = Number(updates[k]);
      if (/^\d+$/.test(k) && n > 0) out.push({ id: k, qty: n });
    });
    return out;
  }
  function renderGifts(bb, s) {
    var box = bb.querySelector('[data-lpe-gifts]');
    var line = bb.querySelector('[data-lpe-giftline]');
    if (!box && !line) return;
    var gifts = previewGifts(s);
    if (gifts === null) return; // filled in once the Gift Manager is ready
    // Display-only gift of the selected option (e.g. NOBL Air(TM)): shown like the PDP gift list,
    // never added to the cart.
    var extra = s.extra;
    var shown = extra ? gifts.concat([{ id: null, qty: extra.qty, display: extra }]) : gifts;
    var countList = (extra && (!box || box.getAttribute('data-extra-count') !== 'false')) ? shown : gifts;
    var units = countList.reduce(function (a, g) { return a + g.qty; }, 0);
    var count = (box && box.getAttribute('data-count') === 'products') ? countList.length : units;
    if (line) {
      var label = (s.giftLabel || '').replace('{count}', count);
      var b = line.querySelector('[data-lpe-f="gift"]');
      if (b) b.textContent = label;
      line.hidden = !count || !label;
    }
    // {gifts} in the sticky bar's price line. A bar that follows the buy box always shows the
    // selected option's count; a fixed bar keeps the count of the option shown on page load.
    qsa('[data-lpe-sticky-gifts]').forEach(function (el) {
      var st = el.closest('[data-lpe-sticky]');
      if (!el.__lpeSet || (st && st.hasAttribute('data-follow'))) { el.textContent = count; el.__lpeSet = true; }
    });
    if (!box) return;
    if (!count) { box.hidden = true; return; }
    var cat = giftCatalog();
    var tpl = box.querySelector('template[data-lpe-gift-fallback]');
    var row = box.querySelector('[data-lpe-gift-row]');
    row.innerHTML = '';
    row.style.gridTemplateColumns = 'repeat(' + Math.min(shown.length, 5) + ',1fr)';
    shown.forEach(function (g) {
      var info = g.display ? { t: g.display.title, i: g.display.img } : (cat[g.id] || {});
      var tile = document.createElement('div');
      tile.className = 'gt';
      if (info.i) {
        var img = document.createElement('img');
        img.src = info.i; img.alt = ''; img.width = 46; img.height = 46; img.loading = 'lazy';
        tile.appendChild(img);
      } else if (tpl) {
        tile.appendChild(tpl.content.cloneNode(true));
      }
      var name = document.createElement('span');
      name.textContent = (info.t || 'Free gift') + (g.qty > 1 ? ' ×' + g.qty : '');
      tile.appendChild(name);
      var free = document.createElement('b');
      free.textContent = 'FREE';
      tile.appendChild(free);
      if (g.display) {
        tile.classList.add('lpe-gt-display');
        if (g.display.info) {
          // Info icon top-right of the tile; opens the same popup as the PDP gift tooltips.
          var ib = document.createElement('button');
          ib.type = 'button'; ib.className = 'lpe-gt-info';
          ib.setAttribute('aria-label', 'More info about ' + g.display.title);
          ib.setAttribute('aria-haspopup', 'dialog');
          ib.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="18" height="18" aria-hidden="true"><circle cx="12" cy="12" r="10" fill="white"></circle><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z"></path></svg>';
          ib.setAttribute('data-lpe-tip', g.display.info);
          tile.appendChild(ib);
        }
      }
      row.appendChild(tile);
    });
    var h = box.querySelector('[data-lpe-gifts-h]');
    if (h) h.textContent = (box.getAttribute('data-heading') || '').replace('{count}', count);
    box.hidden = false;
  }

  /* ---------- buy box ---------- */
  function buyHref(s) {
    if (!s || !s.vid) return null;
    if (s.mode === 'pdp') return s.url + (s.url.indexOf('?') > -1 ? '&' : '?') + 'variant=' + s.vid;
    var base = root + 'cart/add?id=' + s.vid + '&quantity=' + s.qty;
    return s.mode === 'cart' ? base : base + '&return_to=/checkout';
  }
  function activePane(bb) {
    return bb.querySelector('[data-lpe-pane]:not([hidden])') || bb.querySelector('[data-lpe-pane]');
  }
  function setField(bb, key, html, asText) {
    qsa('[data-lpe-f="' + key + '"]', bb).forEach(function (el) {
      if (asText) el.textContent = html; else el.innerHTML = html;
    });
  }
  function apply(bb) {
    var pane = activePane(bb);
    if (!pane) return;
    var sw = pane.querySelector('[data-vid][aria-pressed="true"]') || pane.querySelector('[data-vid]');
    var vid = sw ? sw.getAttribute('data-vid') : null;
    var v = vid && pane.__vars ? pane.__vars[vid] : null;
    setField(bb, 'name', pane.getAttribute('data-name') || '', true);
    setField(bb, 'tagline', pane.getAttribute('data-tagline') || '', true);
    if (v) {
      setField(bb, 'price', v.pf, true);
      setField(bb, 'compare', v.cf, true);
      var fmt = bb.getAttribute('data-save-format') || '';
      qsa('[data-lpe-f="save"]', bb).forEach(function (el) {
        el.textContent = fmt.replace('{save}', v.sf);
        el.hidden = !v.cf;
      });
    }
    var cname = pane.querySelector('[data-lpe-cname]');
    if (cname && sw) cname.textContent = sw.getAttribute('data-name');
    var img = sw && sw.getAttribute('data-img');
    var main = bb.querySelector('[data-lpe-main-img]');
    if (img && main) main.src = img;
    if (img && bb.getAttribute('data-thumb-follows') === 'true') {
      var t0 = bb.querySelector('[data-lpe-thumb]');
      if (t0) { t0.setAttribute('data-img', img); var ti = t0.querySelector('img'); if (ti) ti.src = img; }
    }
    state = {
      bb: bb, mode: bb.getAttribute('data-mode') || 'checkout', vid: vid, v: v, qty: bb.__qty || 1,
      url: pane.getAttribute('data-url') || '', pid: pane.getAttribute('data-pid'),
      name: pane.getAttribute('data-name') || '', giftLabel: pane.getAttribute('data-gift-label') || '',
      extra: pane.getAttribute('data-extra-title') ? {
        title: pane.getAttribute('data-extra-title'), img: pane.getAttribute('data-extra-img') || '',
        qty: Math.max(1, parseInt(pane.getAttribute('data-extra-qty'), 10) || 1), info: pane.getAttribute('data-extra-info') || ''
      } : null,
      soldout: !!(v && v.a === false)
    };
    var href = buyHref(state);
    qsa('[data-lpe-buy]').forEach(function (a) {
      if (href) a.setAttribute('href', href);
      if (state.soldout) a.setAttribute('aria-disabled', 'true'); else a.removeAttribute('aria-disabled');
    });
    qsa('[data-lpe-sticky][data-follow]').forEach(function (st) {
      var t = st.querySelector('[data-st="name"]');
      if (t) t.textContent = state.name;
      var pl = st.querySelector('[data-lpe-sticky-price]');
      var tplStr = st.getAttribute('data-template');
      if (pl && tplStr && v) {
        pl.innerHTML = tplStr.replace('{price}', v.pf).replace('{compare}', v.cf || '').replace('{save}', v.sf).replace('{pct}', v.pct).replace('{gifts}', '<span data-lpe-sticky-gifts></span>');
      }
    });
    renderGifts(bb, state);
    document.dispatchEvent(new CustomEvent('lpe:change', { detail: { vid: vid, name: state.name, qty: state.qty, href: href } }));
  }
  function initBuyBox(bb) {
    if (bb.__lpe) return;
    bb.__lpe = true;
    bb.__qty = 1;
    qsa('[data-lpe-pane]', bb).forEach(function (pane) {
      var data = pane.querySelector('[data-lpe-variants]');
      try { pane.__vars = data ? JSON.parse(data.textContent) : {}; } catch (e) { pane.__vars = {}; }
    });
    bb.addEventListener('click', function (e) {
      var opt = e.target.closest('[data-lpe-opt]');
      if (opt && bb.contains(opt)) {
        var idx = opt.getAttribute('data-lpe-opt');
        qsa('[data-lpe-opt]', bb).forEach(function (o) {
          var on = o === opt;
          o.classList.toggle('on', on);
          var r = o.querySelector('input'); if (r) r.checked = on;
        });
        qsa('[data-lpe-pane]', bb).forEach(function (p) { p.hidden = p.getAttribute('data-lpe-pane') !== idx; });
        apply(bb);
        return;
      }
      var sw = e.target.closest('[data-lpe-pane] [data-vid]');
      if (sw && bb.contains(sw)) {
        qsa('[data-vid]', sw.parentNode).forEach(function (x) { x.setAttribute('aria-pressed', 'false'); });
        sw.setAttribute('aria-pressed', 'true');
        apply(bb);
        return;
      }
      var th = e.target.closest('[data-lpe-thumb]');
      if (th && bb.contains(th)) {
        var main = bb.querySelector('[data-lpe-main-img]');
        if (main) main.src = th.getAttribute('data-img');
        return;
      }
      var q = e.target.closest('[data-lpe-qty]');
      if (q && bb.contains(q)) {
        bb.__qty = Math.min(10, Math.max(1, (bb.__qty || 1) + Number(q.getAttribute('data-lpe-qty'))));
        var val = bb.querySelector('[data-lpe-qty-val]');
        if (val) val.textContent = bb.__qty;
        apply(bb);
      }
    });
    apply(bb);
  }

  /* ---------- buy buttons ---------- */
  function setBusy(on) {
    qsa('[data-lpe-buy]').forEach(function (a) {
      if (on) { a.setAttribute('aria-busy', 'true'); a.classList.add('lpe-busy'); }
      else { a.removeAttribute('aria-busy'); a.classList.remove('lpe-busy'); }
    });
  }
  function fetchCart() {
    return fetch(root + 'cart.js', { credentials: 'same-origin', cache: 'no-store' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; });
  }
  async function addAndGo(s) {
    if (busy) return; // ignore double clicks while one add is running
    busy = true;
    setBusy(true);
    var fallback = function () { window.location.href = buyHref(s); };
    var GM = await waitForGiftManager(4000);
    if (!GM || typeof GM.syncBeforeCheckout !== 'function') {
      // No Gift Manager on the page: use Shopify's own add-to-cart redirect (same as the PDP fallback).
      fallback();
      return;
    }
    // The cart cached by the Gift Manager at page load is out of date once we add: never reuse it.
    var ns = window.NOBLCartSync = window.NOBLCartSync || {};
    ns.writeSeq = (ns.writeSeq || 0) + 1;
    ns.lastCart = null;
    var added = false;
    try {
      var res = await fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        credentials: 'same-origin',
        body: JSON.stringify({ items: [{ id: Number(s.vid), quantity: s.qty }] })
      });
      added = res.ok;
    } catch (e) { added = false; }
    ns.writeSeq = (ns.writeSeq || 0) + 1;
    ns.lastCart = null;
    if (!added) {
      // Let Shopify's /cart/add page show why (e.g. sold out); nothing was added.
      fallback();
      return;
    }
    var verified = false;
    try { verified = await GM.syncBeforeCheckout(); } catch (e) { verified = false; }
    if (verified) {
      // Only leave for checkout when the cart really holds the selected product.
      var lc = ns.lastCart;
      var cart = (lc && lc.seq === ns.writeSeq && lc.cart) ? lc.cart : await fetchCart();
      verified = !!(cart && Array.isArray(cart.items) && cart.items.some(function (i) {
        return String(i.variant_id) === String(s.vid) && i.quantity >= s.qty;
      }));
    }
    var dest = (verified && s.mode !== 'cart') ? root + 'checkout' : cartUrl();
    window.location.assign(dest);
    // Safety net if navigation is blocked: free the buttons again.
    setTimeout(function () { busy = false; setBusy(false); }, 30000);
  }
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('[data-lpe-buy]');
    if (!a || !state) return; // no buy box on the page: the link scrolls to its anchor
    if (state.soldout || busy) { e.preventDefault(); return; }
    if (state.mode === 'pdp') {
      if (designMode) { a.target = '_blank'; a.rel = 'noopener'; }
      return; // href already points to the product page with the selected variant
    }
    e.preventDefault();
    if (designMode) { console.info('[LPE] Add to cart is switched off inside the theme editor. Preview the page to test it.'); return; }
    addAndGo(state);
  });
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) { busy = false; setBusy(false); }
  });

  /* ---------- gift info popup (same behaviour as the PDP gift tooltips) ---------- */
  var tipPop = null, tipBtn = null;
  function closeTip() {
    if (tipPop) tipPop.classList.remove('lpe-tip-popup--active');
    if (tipBtn) tipBtn.setAttribute('aria-expanded', 'false');
    tipBtn = null;
  }
  function tipPopup() {
    if (tipPop) return tipPop;
    tipPop = document.createElement('div');
    tipPop.className = 'lpe-tip-popup';
    tipPop.setAttribute('role', 'dialog');
    tipPop.innerHTML = '<button type="button" class="lpe-tip-close" aria-label="Close"><svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" aria-hidden="true"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg></button><p></p>';
    tipPop.addEventListener('click', function (e) {
      e.stopPropagation();
      if (e.target.closest('.lpe-tip-close')) closeTip();
    });
    document.body.appendChild(tipPop);
    return tipPop;
  }
  function placeTip(btn, pop) {
    var M = 8, icon = btn.getBoundingClientRect(), rect = pop.getBoundingClientRect();
    var left = Math.max(M, Math.min(icon.left + icon.width / 2 - rect.width / 2, window.innerWidth - rect.width - M));
    var below = icon.top - rect.height - 10 < M;
    pop.style.left = left + 'px';
    pop.style.top = (below ? icon.bottom + 10 : icon.top - rect.height - 10) + 'px';
    pop.classList.toggle('lpe-tip-popup--below', below);
    pop.style.setProperty('--lpe-arrow-left', Math.max(10, Math.min(icon.left + icon.width / 2 - left, rect.width - 10)) + 'px');
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-lpe-tip]');
    if (!btn) { closeTip(); return; }
    e.preventDefault(); e.stopPropagation();
    if (tipBtn === btn) { closeTip(); return; }
    var pop = tipPopup();
    pop.querySelector('p').textContent = btn.getAttribute('data-lpe-tip');
    closeTip();
    tipBtn = btn; btn.setAttribute('aria-expanded', 'true');
    pop.classList.add('lpe-tip-popup--active');
    requestAnimationFrame(function () { placeTip(btn, pop); });
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeTip(); });
  window.addEventListener('resize', closeTip);
  window.addEventListener('scroll', closeTip, { passive: true });

  /* ---------- misc ---------- */
  document.addEventListener('click', function (e) {
    var tb = e.target.closest && e.target.closest('.tabs .tb, .tabs .tab');
    if (!tb) return;
    var tabs = tb.closest('.tabs');
    qsa('.tb, .tab', tabs).forEach(function (x) { x.classList.toggle('on', x === tb); });
    qsa('.tp', tabs.parentNode).forEach(function (p) { p.hidden = p.getAttribute('data-t') !== tb.getAttribute('data-t'); });
  });
  /* ---------- carousels ([data-car]: .track + prev/next + dots) ---------- */
  function initCarousels(ctx) {
    qsa('[data-car]', ctx).forEach(function (c) {
      if (c.__lpeCar) return;
      c.__lpeCar = true;
      var t = c.querySelector('.track'), dots = qsa('.dots i', c);
      if (!t) return;
      var go = function (k) { t.scrollBy({ left: k * t.clientWidth * 0.9, behavior: 'smooth' }); };
      var prev = c.querySelector('.prev'), next = c.querySelector('.next');
      if (prev) prev.addEventListener('click', function () { go(-1); });
      if (next) next.addEventListener('click', function () { go(1); });
      t.addEventListener('scroll', function () {
        var best = 0, bd = 1e9;
        Array.prototype.forEach.call(t.children, function (el, i) {
          var dd = Math.abs(el.offsetLeft - t.offsetLeft - t.scrollLeft);
          if (dd < bd) { bd = dd; best = i; }
        });
        dots.forEach(function (x, i) { x.classList.toggle('on', i === best); });
      }, { passive: true });
    });
  }

  /* ---------- "Pick a card" game ([data-lpe-game]) ---------- */
  function initGames(ctx) {
    qsa('[data-lpe-game]', ctx).forEach(function (g) {
      if (g.__lpeGame) return;
      g.__lpeGame = true;
      var split = function (s) { return (s || '').split('|').filter(function (x) { return x; }); };
      var prizes = split(g.getAttribute('data-prizes')), rest = split(g.getAttribute('data-rest'));
      var picks = prizes.length, n = 0;
      var next = g.querySelector('[data-lpe-game-next]'), cnt = g.querySelector('[data-lpe-game-count]');
      var target = g.getAttribute('data-target') || '';
      var label = function (left) {
        return (left === 1 ? g.getAttribute('data-btn-flip-one') : g.getAttribute('data-btn-flip')).replace('{n}', left);
      };
      var esc = function (s) { var d = document.createElement('div'); d.textContent = s; return d.innerHTML; };
      if (next) next.addEventListener('click', function (e) { if (n < picks || !target || designMode) e.preventDefault(); });
      qsa('.card', g).forEach(function (c) {
        c.addEventListener('click', function () {
          if (n >= picks || c.classList.contains('flip')) return;
          c.querySelector('.front').innerHTML = '<small>' + esc(g.getAttribute('data-won') || '') + '</small><b>' + esc(prizes[n]) + '</b>';
          c.classList.add('flip');
          n++;
          if (cnt) cnt.textContent = n + '/' + picks;
          if (n < picks) { if (next) next.textContent = label(picks - n); return; }
          var r = 0;
          qsa('.card:not(.flip)', g).forEach(function (x) {
            x.querySelector('.front').innerHTML = '<b>' + esc(rest[r++ % Math.max(rest.length, 1)] || '') + '</b>';
            x.classList.add('flip', 'dim');
          });
          if (next) { next.textContent = g.getAttribute('data-btn-done') || ''; next.classList.add('ready'); next.removeAttribute('aria-disabled'); }
          var risk = g.querySelector('[data-lpe-game-risk]'); if (risk) risk.hidden = false;
          var rd = g.querySelector('[data-lpe-game-redir]'), sx = g.querySelector('[data-lpe-game-secs]');
          if (!target || designMode) return; // never navigate away inside the theme editor
          if (rd) rd.hidden = false;
          var s = parseInt(g.getAttribute('data-seconds'), 10) || 4;
          var iv = setInterval(function () {
            s--; if (sx) sx.textContent = s;
            if (s <= 0) { clearInterval(iv); window.location.href = target; }
          }, 1000);
        });
      });
    });
  }

  function onScroll() { document.body.classList.toggle('scrolled', window.scrollY > 560); }

  function init(ctx) {
    initVideos(ctx);
    initCarousels(ctx);
    initGames(ctx);
    qsa('[data-lpe-bb]', ctx).forEach(initBuyBox);
    tick();
  }
  function start() {
    init(document);
    setInterval(tick, 1000);
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    // The Gift Manager starts on DOMContentLoaded; show the gifts as soon as it is ready.
    waitForGiftManager(8000).then(function (GM) {
      if (!GM) return;
      qsa('[data-lpe-bb]').forEach(function (bb) { if (bb.__lpe) apply(bb); });
    });
  }
  document.addEventListener('shopify:section:load', function (e) { catalog = null; init(e.target); });

  window.LPECore = { apply: apply, previewGifts: previewGifts, state: function () { return state; } };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
